module.exports = __webpack_public_path__ + "assets/checkGradient.5227e4f0.svg";